var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { MenuItem, Modal, Box, TextField as MuiTextField, Select, Stack, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ReactDatePicker from 'react-datepicker';
import CustomButton from '../../components/buttonComponent/CustomButton';
import { api_service } from '../../api/api_service';
import { api_urls } from '../../api/api_urls';
import { BacklogStatusGroups } from '../../config/constants';
import BacklogFilterSelect from './components/BacklogFilterSelect';
import { FilterPanelWrapper, FilterHeader, FilterBody, FilterSection, StatusChipGroup, StatusChip, FilterFooter, FilterFooterActions, } from './filterStyles';
import { baseColors } from '../../Themes/colors';
import _ from '../../utils/lodash';
import 'react-datepicker/dist/react-datepicker.css';
var DEALER_SEARCH_MIN_CHARS = 3;
var Filter = function (_a) {
    var _b, _c, _d;
    var vendorList = _a.vendorList, selectedVendor = _a.selectedVendor, selectedStatus = _a.selectedStatus, searchText = _a.searchText, selectedUniqueStatus = _a.selectedUniqueStatus, uniqueStatusList = _a.uniqueStatusList, handleResetFilters = _a.handleResetFilters, programsList = _a.programsList, fetchProgramsByVendor = _a.fetchProgramsByVendor, selectedPrograms = _a.selectedPrograms, applyBacklogFilters = _a.applyBacklogFilters, onApply = _a.onApply, onCancel = _a.onCancel, _e = _a.savedFilterList, savedFilterList = _e === void 0 ? [] : _e, _f = _a.selectedSavedFilter, selectedSavedFilter = _f === void 0 ? '' : _f, setSelectedSavedFilter = _a.setSelectedSavedFilter, onSaveAsNewFilter = _a.onSaveAsNewFilter, _g = _a.salesRepList, salesRepList = _g === void 0 ? [] : _g, _h = _a.selectedSalesRep, selectedSalesRep = _h === void 0 ? [] : _h, fetchSalesRepList = _a.fetchSalesRepList, selectedDateRange = _a.selectedDateRange, _j = _a.dealersList, dealersList = _j === void 0 ? [] : _j, _k = _a.selectedDealers, selectedDealers = _k === void 0 ? [] : _k, _l = _a.dealersLoading, dealersLoading = _l === void 0 ? false : _l, _m = _a.dealersLoadingMore, dealersLoadingMore = _m === void 0 ? false : _m, _o = _a.dealersError, dealersError = _o === void 0 ? '' : _o, fetchDealersByVendor = _a.fetchDealersByVendor, searchDealerList = _a.searchDealerList, loadMoreDealerList = _a.loadMoreDealerList;
    var sanitizeVendor = function (vendor) {
        var _a;
        return (__assign({ Id: (_a = vendor === null || vendor === void 0 ? void 0 : vendor.Id) !== null && _a !== void 0 ? _a : 'All' }, ((vendor === null || vendor === void 0 ? void 0 : vendor.Name) !== undefined ? { Name: vendor.Name } : {})));
    };
    var sanitizeVendors = function (vendors) { return (Array.isArray(vendors)
        ? vendors
            .filter(function (vendor) { return Boolean(vendor === null || vendor === void 0 ? void 0 : vendor.Id); })
            .map(function (vendor) { return sanitizeVendor(vendor); })
        : []); };
    var sanitizeUniqueStatusesForApply = function (statuses) { return (Array.isArray(statuses)
        ? statuses
            .filter(function (status) { return Boolean(status === null || status === void 0 ? void 0 : status.label); })
            .map(function (status) {
            var _a;
            return (__assign({ label: status.label, value: (_a = status === null || status === void 0 ? void 0 : status.value) !== null && _a !== void 0 ? _a : null }, ((status === null || status === void 0 ? void 0 : status.statusGroup) !== undefined ? { statusGroup: status.statusGroup } : {})));
        })
        : []); };
    var sanitizeUniqueStatusesForSave = function (statuses) { return (Array.isArray(statuses)
        ? statuses
            .filter(function (status) { return Boolean(status === null || status === void 0 ? void 0 : status.label); })
            .map(function (status) { return (__assign(__assign({ label: status.label }, ((status === null || status === void 0 ? void 0 : status.value) !== undefined ? { value: status.value } : {})), ((status === null || status === void 0 ? void 0 : status.statusGroup) !== undefined ? { statusGroup: status.statusGroup } : {}))); })
        : []); };
    var normalizeFilterToDraftPayload = useCallback(function (savedFilter) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var normalizedFilter = (savedFilter !== null && savedFilter !== void 0 ? savedFilter : {});
        var resolvedVendor = sanitizeVendor((_a = normalizedFilter.vendor) !== null && _a !== void 0 ? _a : { Id: 'All', Name: 'All' });
        var resolvedVendors = Array.isArray(normalizedFilter.portalName)
            ? sanitizeVendors(normalizedFilter.portalName)
            : Array.isArray(normalizedFilter.vendors)
                ? sanitizeVendors(normalizedFilter.vendors)
                : (resolvedVendor === null || resolvedVendor === void 0 ? void 0 : resolvedVendor.Id) && resolvedVendor.Id !== 'All'
                    ? [resolvedVendor]
                    : [];
        var selectedVendorFromSavedFilter = (_b = resolvedVendors[0]) !== null && _b !== void 0 ? _b : resolvedVendor;
        var resolvedStatus = (_c = normalizedFilter.statusGroup) !== null && _c !== void 0 ? _c : { label: '', value: null };
        var resolvedPrograms = Array.isArray(normalizedFilter.programs) ? normalizedFilter.programs : [];
        var resolvedUniqueStatus = Array.isArray(normalizedFilter.status)
            ? sanitizeUniqueStatusesForApply(normalizedFilter.status)
            : Array.isArray(normalizedFilter.uniqueStatus)
                ? sanitizeUniqueStatusesForApply(normalizedFilter.uniqueStatus)
                : [];
        var resolvedSalesRep = Array.isArray(normalizedFilter.salesRep) ? normalizedFilter.salesRep : [];
        var resolvedDealers = Array.isArray(normalizedFilter.dealers) ? normalizedFilter.dealers : [];
        var resolvedDateRange = buildDateRangePayload((_e = (_d = normalizedFilter.ForecastDataRange) === null || _d === void 0 ? void 0 : _d.StartDate) !== null && _e !== void 0 ? _e : '', (_g = (_f = normalizedFilter.ForecastDataRange) === null || _f === void 0 ? void 0 : _f.EndDate) !== null && _g !== void 0 ? _g : '');
        return __assign({ vendor: selectedVendorFromSavedFilter, statusGroup: resolvedStatus, programs: resolvedPrograms, searchText: (_h = normalizedFilter.searchText) !== null && _h !== void 0 ? _h : '', uniqueStatus: resolvedUniqueStatus, salesRep: resolvedSalesRep, dealers: resolvedDealers }, (resolvedDateRange ? { ForecastDataRange: resolvedDateRange } : {}));
    }, [sanitizeUniqueStatusesForApply]);
    var toComparableFilterState = useCallback(function (payload) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        return ({
            vendorId: String((_b = (_a = payload === null || payload === void 0 ? void 0 : payload.vendor) === null || _a === void 0 ? void 0 : _a.Id) !== null && _b !== void 0 ? _b : 'All'),
            statusGroupValue: String((_d = (_c = payload === null || payload === void 0 ? void 0 : payload.statusGroup) === null || _c === void 0 ? void 0 : _c.value) !== null && _d !== void 0 ? _d : ''),
            searchText: (_e = payload === null || payload === void 0 ? void 0 : payload.searchText) !== null && _e !== void 0 ? _e : '',
            programs: (Array.isArray(payload === null || payload === void 0 ? void 0 : payload.programs) ? payload.programs : [])
                .map(function (program) { var _a, _b, _c, _d; return String((_d = (_c = (_b = (_a = program === null || program === void 0 ? void 0 : program.value) !== null && _a !== void 0 ? _a : program === null || program === void 0 ? void 0 : program.Id) !== null && _b !== void 0 ? _b : program === null || program === void 0 ? void 0 : program.id) !== null && _c !== void 0 ? _c : program) !== null && _d !== void 0 ? _d : ''); })
                .sort(),
            uniqueStatus: (Array.isArray(payload === null || payload === void 0 ? void 0 : payload.uniqueStatus) ? payload.uniqueStatus : [])
                .map(function (status) {
                var _a, _b, _c;
                return ({
                    label: String((_a = status === null || status === void 0 ? void 0 : status.label) !== null && _a !== void 0 ? _a : ''),
                    value: String((_b = status === null || status === void 0 ? void 0 : status.value) !== null && _b !== void 0 ? _b : ''),
                    statusGroup: String((_c = status === null || status === void 0 ? void 0 : status.statusGroup) !== null && _c !== void 0 ? _c : ''),
                });
            })
                .sort(function (a, b) { return "".concat(a.label, "|").concat(a.value, "|").concat(a.statusGroup).localeCompare("".concat(b.label, "|").concat(b.value, "|").concat(b.statusGroup)); }),
            salesRep: (Array.isArray(payload === null || payload === void 0 ? void 0 : payload.salesRep) ? payload.salesRep : [])
                .map(function (salesRep) { var _a, _b; return String((_b = (_a = salesRep === null || salesRep === void 0 ? void 0 : salesRep.value) !== null && _a !== void 0 ? _a : salesRep === null || salesRep === void 0 ? void 0 : salesRep.label) !== null && _b !== void 0 ? _b : ''); })
                .sort(),
            dealers: (Array.isArray(payload === null || payload === void 0 ? void 0 : payload.dealers) ? payload.dealers : [])
                .map(function (dealer) { var _a, _b, _c; return String((_c = (_b = (_a = dealer === null || dealer === void 0 ? void 0 : dealer.AccountAspireOId) !== null && _a !== void 0 ? _a : dealer === null || dealer === void 0 ? void 0 : dealer.value) !== null && _b !== void 0 ? _b : dealer === null || dealer === void 0 ? void 0 : dealer.label) !== null && _c !== void 0 ? _c : ''); })
                .sort(),
            ForecastDataRangeStartDate: (_g = (_f = payload === null || payload === void 0 ? void 0 : payload.ForecastDataRange) === null || _f === void 0 ? void 0 : _f.StartDate) !== null && _g !== void 0 ? _g : '',
            ForecastDataRangeEndDate: (_j = (_h = payload === null || payload === void 0 ? void 0 : payload.ForecastDataRange) === null || _h === void 0 ? void 0 : _h.EndDate) !== null && _j !== void 0 ? _j : '',
        });
    }, []);
    var normalizeDateForPayload = function (value) {
        if (!value) {
            return '';
        }
        var trimmedValue = value.trim();
        var yyyyMmDdPattern = /^\d{4}-\d{2}-\d{2}$/;
        if (!yyyyMmDdPattern.test(trimmedValue)) {
            return '';
        }
        return trimmedValue;
    };
    var getDateRangeValidationError = function (startDateRaw, endDateRaw) {
        var startDate = normalizeDateForPayload(startDateRaw);
        var endDate = normalizeDateForPayload(endDateRaw);
        if (!startDate) {
            return '';
        }
        if (!endDate) {
            return '';
        }
        if (endDate < startDate) {
            return 'End Date cannot be earlier than Start Date.';
        }
        return '';
    };
    var buildDateRangePayload = function (startDateRaw, endDateRaw) {
        var startDate = normalizeDateForPayload(startDateRaw);
        if (!startDate) {
            return undefined;
        }
        var endDate = normalizeDateForPayload(endDateRaw);
        return {
            StartDate: startDate,
            EndDate: endDate || startDate,
        };
    };
    var _p = useState(sanitizeVendor(selectedVendor)), draftVendor = _p[0], setDraftVendor = _p[1];
    var _q = useState(selectedStatus), draftStatus = _q[0], setDraftStatus = _q[1];
    var _r = useState(searchText), draftSearchText = _r[0], setDraftSearchText = _r[1];
    var _s = useState(selectedPrograms), draftPrograms = _s[0], setDraftPrograms = _s[1];
    var _t = useState(selectedUniqueStatus), draftUniqueStatus = _t[0], setDraftUniqueStatus = _t[1];
    var _u = useState(Array.isArray(selectedSalesRep) ? selectedSalesRep : []), draftSalesRep = _u[0], setDraftSalesRep = _u[1];
    var _v = useState(Array.isArray(selectedDealers) ? selectedDealers : []), draftDealers = _v[0], setDraftDealers = _v[1];
    var _w = useState(normalizeDateForPayload((_b = selectedDateRange === null || selectedDateRange === void 0 ? void 0 : selectedDateRange.StartDate) !== null && _b !== void 0 ? _b : '')), draftForecastStartDate = _w[0], setDraftForecastStartDate = _w[1];
    var _x = useState(normalizeDateForPayload((_c = selectedDateRange === null || selectedDateRange === void 0 ? void 0 : selectedDateRange.EndDate) !== null && _c !== void 0 ? _c : '')), draftForecastEndDate = _x[0], setDraftForecastEndDate = _x[1];
    var _y = useState(selectedSavedFilter), draftSavedFilter = _y[0], setDraftSavedFilter = _y[1];
    var _z = useState([]), fetchedSavedFilters = _z[0], setFetchedSavedFilters = _z[1];
    var _0 = useState(false), saveFilterModalOpen = _0[0], setSaveFilterModalOpen = _0[1];
    var _1 = useState(''), editingFilterId = _1[0], setEditingFilterId = _1[1];
    var _2 = useState(''), customFilterName = _2[0], setCustomFilterName = _2[1];
    var _3 = useState(''), customFilterNameError = _3[0], setCustomFilterNameError = _3[1];
    var _4 = useState(false), isResetPending = _4[0], setIsResetPending = _4[1];
    var _5 = useState(false), isResetAnimating = _5[0], setIsResetAnimating = _5[1];
    var resetAnimationTimeoutRef = useRef(null);
    var salesRepListFetchedRef = useRef(false);
    var dealersOpenedRef = useRef(false);
    var hasUserModifiedDraftRef = useRef(false);
    var loadProgramsByVendor = useCallback(function (vendorId) { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!fetchProgramsByVendor) {
                        return [2];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4, fetchProgramsByVendor(vendorId && String(vendorId) !== 'All' ? vendorId : undefined)];
                case 2:
                    _a.sent();
                    return [3, 4];
                case 3:
                    error_1 = _a.sent();
                    return [3, 4];
                case 4: return [2];
            }
        });
    }); }, [fetchProgramsByVendor]);
    var upsertSavedFilter = useCallback(function (nextFilter) {
        setFetchedSavedFilters(function (prev) {
            var _a;
            var existingIndex = prev.findIndex(function (item) { var _a, _b; return String(item.value) === String(nextFilter.value) || ((_a = item.label) === null || _a === void 0 ? void 0 : _a.trim()) === ((_b = nextFilter.label) === null || _b === void 0 ? void 0 : _b.trim()); });
            if (existingIndex >= 0) {
                var updated = __spreadArray([], prev, true);
                updated[existingIndex] = __assign(__assign(__assign({}, updated[existingIndex]), nextFilter), { filters: (_a = nextFilter.filters) !== null && _a !== void 0 ? _a : updated[existingIndex].filters });
                return updated;
            }
            return __spreadArray([nextFilter], prev, true);
        });
    }, []);
    var resolveSavedFilterValueFromResponse = function (response) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10;
        return ((_10 = (_8 = (_6 = (_4 = (_2 = (_0 = (_y = (_w = (_t = (_q = (_m = (_j = (_f = (_c = (_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.RecordId) !== null && _c !== void 0 ? _c : (_e = (_d = response === null || response === void 0 ? void 0 : response.data) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.Id) !== null && _f !== void 0 ? _f : (_h = (_g = response === null || response === void 0 ? void 0 : response.data) === null || _g === void 0 ? void 0 : _g.data) === null || _h === void 0 ? void 0 : _h.FilterId) !== null && _j !== void 0 ? _j : (_l = (_k = response === null || response === void 0 ? void 0 : response.data) === null || _k === void 0 ? void 0 : _k.data) === null || _l === void 0 ? void 0 : _l.value) !== null && _m !== void 0 ? _m : (_p = (_o = response === null || response === void 0 ? void 0 : response.data) === null || _o === void 0 ? void 0 : _o.data) === null || _p === void 0 ? void 0 : _p.id) !== null && _q !== void 0 ? _q : (_s = (_r = response === null || response === void 0 ? void 0 : response.data) === null || _r === void 0 ? void 0 : _r.data) === null || _s === void 0 ? void 0 : _s.OId) !== null && _t !== void 0 ? _t : (_v = (_u = response === null || response === void 0 ? void 0 : response.data) === null || _u === void 0 ? void 0 : _u.data) === null || _v === void 0 ? void 0 : _v.PreferenceId) !== null && _w !== void 0 ? _w : (_x = response === null || response === void 0 ? void 0 : response.data) === null || _x === void 0 ? void 0 : _x.RecordId) !== null && _y !== void 0 ? _y : (_z = response === null || response === void 0 ? void 0 : response.data) === null || _z === void 0 ? void 0 : _z.Id) !== null && _0 !== void 0 ? _0 : (_1 = response === null || response === void 0 ? void 0 : response.data) === null || _1 === void 0 ? void 0 : _1.FilterId) !== null && _2 !== void 0 ? _2 : (_3 = response === null || response === void 0 ? void 0 : response.data) === null || _3 === void 0 ? void 0 : _3.value) !== null && _4 !== void 0 ? _4 : (_5 = response === null || response === void 0 ? void 0 : response.data) === null || _5 === void 0 ? void 0 : _5.id) !== null && _6 !== void 0 ? _6 : (_7 = response === null || response === void 0 ? void 0 : response.data) === null || _7 === void 0 ? void 0 : _7.OId) !== null && _8 !== void 0 ? _8 : (_9 = response === null || response === void 0 ? void 0 : response.data) === null || _9 === void 0 ? void 0 : _9.PreferenceId) !== null && _10 !== void 0 ? _10 : '');
    };
    var isSavedFilterEntry = function (item) {
        if (!item || typeof item !== 'object' || Array.isArray(item)) {
            return false;
        }
        return Boolean(item.label
            || item.name
            || item.FilterName
            || item.PreferenceName
            || item.value !== undefined
            || item.id !== undefined
            || item.Id !== undefined
            || item.RecordId !== undefined
            || item.OId !== undefined
            || item.PreferenceId !== undefined
            || item.FilterId !== undefined
            || item.filters
            || item.FilterData
            || item.PreferenceData
            || item.FilterConfig);
    };
    var normalizeSavedFilterOptions = function (response) {
        var _a, _b, _c, _d, _e;
        var candidateCollections = [
            (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.data,
            response === null || response === void 0 ? void 0 : response.data,
            (_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.preferences,
            (_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.savedFilters,
            (_d = response === null || response === void 0 ? void 0 : response.data) === null || _d === void 0 ? void 0 : _d.filters,
            (_e = response === null || response === void 0 ? void 0 : response.data) === null || _e === void 0 ? void 0 : _e.FilterConfig,
            response === null || response === void 0 ? void 0 : response.preferences,
            response === null || response === void 0 ? void 0 : response.savedFilters,
            response === null || response === void 0 ? void 0 : response.filters,
            response === null || response === void 0 ? void 0 : response.FilterConfig,
        ];
        var arrayCandidate = candidateCollections.find(function (item) { return Array.isArray(item); });
        var objectCandidate = candidateCollections.find(function (item) { return isSavedFilterEntry(item); });
        var rawFilters = arrayCandidate !== null && arrayCandidate !== void 0 ? arrayCandidate : (objectCandidate ? [objectCandidate] : []);
        return rawFilters
            .map(function (item, index) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
            return ({
                label: (_f = (_e = (_c = (_b = (_a = item === null || item === void 0 ? void 0 : item.FilterName) !== null && _a !== void 0 ? _a : item === null || item === void 0 ? void 0 : item.label) !== null && _b !== void 0 ? _b : item === null || item === void 0 ? void 0 : item.name) !== null && _c !== void 0 ? _c : (_d = item === null || item === void 0 ? void 0 : item.FilterConfig) === null || _d === void 0 ? void 0 : _d.filterName) !== null && _e !== void 0 ? _e : item === null || item === void 0 ? void 0 : item.PreferenceName) !== null && _f !== void 0 ? _f : "Saved Filter ".concat(index + 1),
                value: (_o = (_m = (_l = (_k = (_j = (_h = (_g = item === null || item === void 0 ? void 0 : item.RecordId) !== null && _g !== void 0 ? _g : item === null || item === void 0 ? void 0 : item.Id) !== null && _h !== void 0 ? _h : item === null || item === void 0 ? void 0 : item.FilterId) !== null && _j !== void 0 ? _j : item === null || item === void 0 ? void 0 : item.value) !== null && _k !== void 0 ? _k : item === null || item === void 0 ? void 0 : item.id) !== null && _l !== void 0 ? _l : item === null || item === void 0 ? void 0 : item.OId) !== null && _m !== void 0 ? _m : item === null || item === void 0 ? void 0 : item.PreferenceId) !== null && _o !== void 0 ? _o : "".concat(index),
                filters: (_t = (_s = (_r = (_q = (_p = item === null || item === void 0 ? void 0 : item.FilterConfig) !== null && _p !== void 0 ? _p : item === null || item === void 0 ? void 0 : item.filters) !== null && _q !== void 0 ? _q : item === null || item === void 0 ? void 0 : item.FilterData) !== null && _r !== void 0 ? _r : item === null || item === void 0 ? void 0 : item.PreferenceData) !== null && _s !== void 0 ? _s : item === null || item === void 0 ? void 0 : item.data) !== null && _t !== void 0 ? _t : item,
            });
        })
            .filter(function (item) { return item.label && item.value !== undefined && item.value !== null; });
    };
    var applySavedFilterToDraft = useCallback(function (savedFilter) {
        var _a, _b;
        var normalizedPayload = normalizeFilterToDraftPayload(savedFilter);
        var nextDateRange = normalizedPayload.ForecastDataRange;
        var nextStartDate = normalizeDateForPayload((_a = nextDateRange === null || nextDateRange === void 0 ? void 0 : nextDateRange.StartDate) !== null && _a !== void 0 ? _a : '');
        var nextEndDate = normalizeDateForPayload((_b = nextDateRange === null || nextDateRange === void 0 ? void 0 : nextDateRange.EndDate) !== null && _b !== void 0 ? _b : '');
        setDraftVendor(normalizedPayload.vendor);
        setDraftStatus(normalizedPayload.statusGroup);
        setDraftPrograms(normalizedPayload.programs);
        setDraftSearchText(normalizedPayload.searchText);
        setDraftUniqueStatus(normalizedPayload.uniqueStatus);
        setDraftSalesRep(normalizedPayload.salesRep);
        setDraftDealers(normalizedPayload.dealers);
        setDraftForecastStartDate(nextStartDate);
        setDraftForecastEndDate(nextStartDate ? nextEndDate : '');
    }, [normalizeFilterToDraftPayload]);
    var fetchAdminPreferences = function (preferredSelection) { return __awaiter(void 0, void 0, void 0, function () {
        var response, nextSavedFilters, preferredByValue, preferredByLabel, resolvedPreferredFilter, hasSelectedSavedFilter, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4, api_service.get({
                            endPoint: api_urls.ADMIN_PREFERENCES,
                            payLoad: { ConfigType: "APP_MANAGMENT_FILTER_CONFIG" },
                            showLoader: false,
                        })];
                case 1:
                    response = _a.sent();
                    nextSavedFilters = normalizeSavedFilterOptions(response);
                    setFetchedSavedFilters(nextSavedFilters);
                    if (nextSavedFilters.length === 0) {
                        setDraftSavedFilter('');
                        return [2];
                    }
                    preferredByValue = (preferredSelection === null || preferredSelection === void 0 ? void 0 : preferredSelection.value) !== undefined
                        && (preferredSelection === null || preferredSelection === void 0 ? void 0 : preferredSelection.value) !== null
                        && (preferredSelection === null || preferredSelection === void 0 ? void 0 : preferredSelection.value) !== ''
                        ? nextSavedFilters.find(function (item) { return String(item.value) === String(preferredSelection.value); })
                        : undefined;
                    preferredByLabel = !preferredByValue && (preferredSelection === null || preferredSelection === void 0 ? void 0 : preferredSelection.label)
                        ? nextSavedFilters.find(function (item) { var _a, _b; return ((_a = item.label) === null || _a === void 0 ? void 0 : _a.trim()) === ((_b = preferredSelection.label) === null || _b === void 0 ? void 0 : _b.trim()); })
                        : undefined;
                    resolvedPreferredFilter = preferredByValue !== null && preferredByValue !== void 0 ? preferredByValue : preferredByLabel;
                    if (resolvedPreferredFilter) {
                        setDraftSavedFilter(resolvedPreferredFilter.value);
                        return [2];
                    }
                    hasSelectedSavedFilter = nextSavedFilters.some(function (item) { return String(item.value) === String(selectedSavedFilter); });
                    if (selectedSavedFilter !== '' && hasSelectedSavedFilter) {
                        setDraftSavedFilter(selectedSavedFilter);
                        return [2];
                    }
                    setDraftSavedFilter('');
                    return [3, 3];
                case 2:
                    error_2 = _a.sent();
                    setFetchedSavedFilters([]);
                    setDraftSavedFilter('');
                    return [3, 3];
                case 3: return [2];
            }
        });
    }); };
    useEffect(function () {
        var isMounted = true;
        var loadInitialSavedFilters = function () { return __awaiter(void 0, void 0, void 0, function () {
            var error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, fetchAdminPreferences()];
                    case 1:
                        _a.sent();
                        if (!isMounted) {
                            return [2];
                        }
                        return [3, 3];
                    case 2:
                        error_3 = _a.sent();
                        if (isMounted) {
                            setFetchedSavedFilters([]);
                            setDraftSavedFilter('');
                        }
                        return [3, 3];
                    case 3: return [2];
                }
            });
        }); };
        loadInitialSavedFilters();
        return function () {
            isMounted = false;
        };
    }, []);
    useEffect(function () {
        var selectedSavedFilterItem = fetchedSavedFilters.find(function (item) { return String(item.value) === String(selectedSavedFilter); });
        if (selectedSavedFilter && (selectedSavedFilterItem === null || selectedSavedFilterItem === void 0 ? void 0 : selectedSavedFilterItem.filters) && !hasUserModifiedDraftRef.current) {
            applySavedFilterToDraft(selectedSavedFilterItem.filters);
            setDraftSavedFilter(selectedSavedFilter);
        }
    }, [applySavedFilterToDraft, fetchedSavedFilters, selectedSavedFilter]);
    useEffect(function () {
        var sanitizedSelectedVendor = sanitizeVendor(selectedVendor);
        setDraftVendor(sanitizedSelectedVendor);
        setIsResetPending(false);
    }, [selectedVendor]);
    useEffect(function () {
        loadProgramsByVendor(draftVendor === null || draftVendor === void 0 ? void 0 : draftVendor.Id);
    }, [draftVendor === null || draftVendor === void 0 ? void 0 : draftVendor.Id, loadProgramsByVendor]);
    useEffect(function () {
        if (!dealersOpenedRef.current || !fetchDealersByVendor)
            return;
        setDraftDealers([]);
        fetchDealersByVendor(draftVendor === null || draftVendor === void 0 ? void 0 : draftVendor.Id, true);
    }, [draftVendor === null || draftVendor === void 0 ? void 0 : draftVendor.Id]);
    useEffect(function () { setDraftStatus(selectedStatus); setIsResetPending(false); }, [selectedStatus]);
    useEffect(function () { setDraftSearchText(searchText); setIsResetPending(false); }, [searchText]);
    useEffect(function () { setDraftPrograms(selectedPrograms); setIsResetPending(false); }, [selectedPrograms]);
    useEffect(function () {
        setDraftUniqueStatus(sanitizeUniqueStatusesForApply(selectedUniqueStatus));
        setIsResetPending(false);
    }, [selectedUniqueStatus]);
    useEffect(function () {
        if (Array.isArray(selectedSalesRep)) {
            setDraftSalesRep(selectedSalesRep);
            setIsResetPending(false);
        }
    }, [selectedSalesRep]);
    useEffect(function () {
        if (Array.isArray(selectedDealers)) {
            setDraftDealers(selectedDealers);
            setIsResetPending(false);
        }
    }, [selectedDealers]);
    useEffect(function () {
        var _a, _b;
        var nextStartDate = normalizeDateForPayload((_a = selectedDateRange === null || selectedDateRange === void 0 ? void 0 : selectedDateRange.StartDate) !== null && _a !== void 0 ? _a : '');
        var nextEndDate = normalizeDateForPayload((_b = selectedDateRange === null || selectedDateRange === void 0 ? void 0 : selectedDateRange.EndDate) !== null && _b !== void 0 ? _b : '');
        setDraftForecastStartDate(nextStartDate);
        setDraftForecastEndDate(nextStartDate ? nextEndDate : '');
        setIsResetPending(false);
    }, [selectedDateRange]);
    useEffect(function () {
        hasUserModifiedDraftRef.current = false;
        setDraftSavedFilter(selectedSavedFilter);
        setIsResetPending(false);
    }, [selectedSavedFilter]);
    useEffect(function () {
        return function () {
            if (resetAnimationTimeoutRef.current) {
                clearTimeout(resetAnimationTimeoutRef.current);
            }
        };
    }, []);
    var onDraftStatusChipClick = function (status) {
        hasUserModifiedDraftRef.current = true;
        setDraftStatus({ label: status.label, value: status.value });
        setDraftUniqueStatus([]);
        setIsResetPending(false);
    };
    var handleDraftProgramsChange = function (values) {
        hasUserModifiedDraftRef.current = true;
        setDraftPrograms(values);
        setIsResetPending(false);
    };
    var handleDraftUniqueStatusChange = function (values) {
        hasUserModifiedDraftRef.current = true;
        setDraftUniqueStatus(sanitizeUniqueStatusesForApply(Array.isArray(values) ? values : []));
        setIsResetPending(false);
    };
    var handleDraftVendorChange = function (value) {
        hasUserModifiedDraftRef.current = true;
        setDraftVendor(sanitizeVendor(value !== null && value !== void 0 ? value : { Id: 'All' }));
        setDraftPrograms([]);
        setIsResetPending(false);
    };
    var handleDraftSalesRepChange = function (value) {
        hasUserModifiedDraftRef.current = true;
        setDraftSalesRep(value ? [value] : []);
        setIsResetPending(false);
    };
    var handleDraftDealersChange = function (values) {
        hasUserModifiedDraftRef.current = true;
        setDraftDealers(Array.isArray(values) ? values : []);
        setIsResetPending(false);
    };
    var handleDraftForecastStartDateChange = function (value) {
        var nextStartDate = normalizeDateForPayload(value);
        hasUserModifiedDraftRef.current = true;
        setDraftForecastStartDate(nextStartDate);
        if (!nextStartDate) {
            setDraftForecastEndDate('');
        }
        setIsResetPending(false);
    };
    var handleDraftForecastEndDateChange = function (value) {
        hasUserModifiedDraftRef.current = true;
        setDraftForecastEndDate(normalizeDateForPayload(value));
        setIsResetPending(false);
    };
    var handleDraftForecastDateRangeChange = function (value) {
        var startDate = value[0], endDate = value[1];
        hasUserModifiedDraftRef.current = true;
        setDraftForecastStartDate(startDate ? "".concat(startDate.getFullYear(), "-").concat(String(startDate.getMonth() + 1).padStart(2, '0'), "-").concat(String(startDate.getDate()).padStart(2, '0')) : '');
        setDraftForecastEndDate(endDate ? "".concat(endDate.getFullYear(), "-").concat(String(endDate.getMonth() + 1).padStart(2, '0'), "-").concat(String(endDate.getDate()).padStart(2, '0')) : '');
        setIsResetPending(false);
    };
    var handleSalesRepDropdownOpen = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(!salesRepListFetchedRef.current && fetchSalesRepList)) return [3, 4];
                    salesRepListFetchedRef.current = true;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4, fetchSalesRepList()];
                case 2:
                    _a.sent();
                    return [3, 4];
                case 3:
                    error_4 = _a.sent();
                    salesRepListFetchedRef.current = false;
                    return [3, 4];
                case 4: return [2];
            }
        });
    }); }, [fetchSalesRepList]);
    var handleDealersDropdownOpen = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(!dealersOpenedRef.current && fetchDealersByVendor)) return [3, 4];
                    dealersOpenedRef.current = true;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4, fetchDealersByVendor(draftVendor === null || draftVendor === void 0 ? void 0 : draftVendor.Id, true)];
                case 2:
                    _a.sent();
                    return [3, 4];
                case 3:
                    error_5 = _a.sent();
                    dealersOpenedRef.current = false;
                    return [3, 4];
                case 4: return [2];
            }
        });
    }); }, [fetchDealersByVendor, draftVendor === null || draftVendor === void 0 ? void 0 : draftVendor.Id]);
    var debouncedSearchDealerList = useMemo(function () { return _.debounce(function (value, vendorId) {
        searchDealerList === null || searchDealerList === void 0 ? void 0 : searchDealerList(value, vendorId);
    }, 400); }, [searchDealerList]);
    var handleDealersInputChange = useCallback(function (value) {
        var trimmedValue = value.trim();
        if (trimmedValue.length === 0) {
            debouncedSearchDealerList.cancel();
            searchDealerList === null || searchDealerList === void 0 ? void 0 : searchDealerList('', draftVendor === null || draftVendor === void 0 ? void 0 : draftVendor.Id);
            return;
        }
        if (trimmedValue.length < DEALER_SEARCH_MIN_CHARS) {
            debouncedSearchDealerList.cancel();
            return;
        }
        debouncedSearchDealerList(trimmedValue, draftVendor === null || draftVendor === void 0 ? void 0 : draftVendor.Id);
    }, [debouncedSearchDealerList, searchDealerList, draftVendor === null || draftVendor === void 0 ? void 0 : draftVendor.Id]);
    var handleDealersLoadMore = useCallback(function () {
        loadMoreDealerList === null || loadMoreDealerList === void 0 ? void 0 : loadMoreDealerList(draftVendor === null || draftVendor === void 0 ? void 0 : draftVendor.Id);
    }, [loadMoreDealerList, draftVendor === null || draftVendor === void 0 ? void 0 : draftVendor.Id]);
    useEffect(function () {
        return function () {
            debouncedSearchDealerList.cancel();
        };
    }, [debouncedSearchDealerList]);
    var handleDraftReset = function () {
        hasUserModifiedDraftRef.current = true;
        setDraftVendor({ Id: 'All', Name: 'All' });
        setDraftStatus({ label: '', value: null });
        setDraftSearchText('');
        setDraftPrograms([]);
        setDraftUniqueStatus([]);
        setDraftSalesRep([]);
        setDraftDealers([]);
        setDraftForecastStartDate('');
        setDraftForecastEndDate('');
        setDraftSavedFilter('');
        setIsResetPending(true);
    };
    var handleResetClick = function () {
        handleDraftReset();
        setIsResetAnimating(true);
        setSelectedSavedFilter === null || setSelectedSavedFilter === void 0 ? void 0 : setSelectedSavedFilter('');
        applyBacklogFilters({
            vendor: { Id: 'All', Name: 'All' },
            status: { label: '', value: null },
            programs: [],
            searchText: '',
            uniqueStatus: [],
            salesRep: [],
            dealers: [],
        });
        setIsResetPending(false);
        if (resetAnimationTimeoutRef.current) {
            clearTimeout(resetAnimationTimeoutRef.current);
        }
        resetAnimationTimeoutRef.current = setTimeout(function () {
            setIsResetAnimating(false);
        }, 500);
    };
    var filteredUniqueStatusList = (uniqueStatusList !== null && uniqueStatusList !== void 0 ? uniqueStatusList : []).filter(function (option) {
        if (!(draftStatus === null || draftStatus === void 0 ? void 0 : draftStatus.value) || draftStatus.value === 'All')
            return true;
        return option.statusGroup === draftStatus.value;
    });
    var getDraftFilterPayload = function () { return (__assign(__assign({}, (buildDateRangePayload(draftForecastStartDate, draftForecastEndDate)
        ? { ForecastDataRange: buildDateRangePayload(draftForecastStartDate, draftForecastEndDate) }
        : {})), { vendor: sanitizeVendor(draftVendor), statusGroup: draftStatus, programs: Array.isArray(draftPrograms) ? draftPrograms : [], searchText: draftSearchText, uniqueStatus: sanitizeUniqueStatusesForApply(Array.isArray(draftUniqueStatus) ? draftUniqueStatus : []), salesRep: Array.isArray(draftSalesRep) ? draftSalesRep : [], dealers: Array.isArray(draftDealers) ? draftDealers : [] })); };
    var parsePayloadDate = function (value) {
        var normalized = normalizeDateForPayload(value);
        if (!normalized) {
            return null;
        }
        var parsedDate = new Date("".concat(normalized, "T00:00:00"));
        return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
    };
    var handleSavedFilterChange = function (value) {
        hasUserModifiedDraftRef.current = false;
        setDraftSavedFilter(value);
        setIsResetPending(false);
        if (value === '' || value === null || value === undefined) {
            return;
        }
        var selectedSavedFilterItem = savedFilterOptions.find(function (item) { return String(item.value) === String(value); });
        if (selectedSavedFilterItem === null || selectedSavedFilterItem === void 0 ? void 0 : selectedSavedFilterItem.filters) {
            applySavedFilterToDraft(selectedSavedFilterItem.filters);
        }
    };
    var savedFilterOptions = fetchedSavedFilters;
    var selectedDraftSavedFilterItem = useMemo(function () { return savedFilterOptions.find(function (item) { return String(item.value) === String(draftSavedFilter); }); }, [draftSavedFilter, savedFilterOptions]);
    var isSavedFilterDirty = useMemo(function () {
        if (!draftSavedFilter || !selectedDraftSavedFilterItem) {
            return false;
        }
        var selectedFilterPayload = normalizeFilterToDraftPayload(selectedDraftSavedFilterItem.filters);
        var nextDateRange = buildDateRangePayload(draftForecastStartDate, draftForecastEndDate);
        var currentDraftPayload = __assign(__assign({}, (nextDateRange ? { ForecastDataRange: nextDateRange } : {})), { vendor: sanitizeVendor(draftVendor), statusGroup: draftStatus, programs: Array.isArray(draftPrograms) ? draftPrograms : [], searchText: draftSearchText, uniqueStatus: sanitizeUniqueStatusesForApply(Array.isArray(draftUniqueStatus) ? draftUniqueStatus : []), salesRep: Array.isArray(draftSalesRep) ? draftSalesRep : [], dealers: Array.isArray(draftDealers) ? draftDealers : [] });
        return JSON.stringify(toComparableFilterState(currentDraftPayload)) !== JSON.stringify(toComparableFilterState(selectedFilterPayload));
    }, [
        draftSavedFilter,
        selectedDraftSavedFilterItem,
        normalizeFilterToDraftPayload,
        sanitizeVendor,
        draftVendor,
        draftStatus,
        draftPrograms,
        draftSearchText,
        draftUniqueStatus,
        sanitizeUniqueStatusesForApply,
        draftSalesRep,
        draftDealers,
        draftForecastStartDate,
        draftForecastEndDate,
        toComparableFilterState,
    ]);
    var disableSaveAsNewFilter = Boolean(draftSavedFilter && selectedDraftSavedFilterItem) && !isSavedFilterDirty;
    var handleOpenSaveModal = function () {
        setEditingFilterId('');
        setCustomFilterName('');
        setCustomFilterNameError('');
        setSaveFilterModalOpen(true);
    };
    var handleOpenUpdateModal = function () {
        var _a;
        if (!draftSavedFilter || !selectedDraftSavedFilterItem) {
            return;
        }
        setEditingFilterId(draftSavedFilter);
        setCustomFilterName((_a = selectedDraftSavedFilterItem.label) !== null && _a !== void 0 ? _a : '');
        setCustomFilterNameError('');
        setSaveFilterModalOpen(true);
    };
    var handleSaveNewFilter = function () { return __awaiter(void 0, void 0, void 0, function () {
        var trimmedName, isEditing, payload, response, savedFilterValue, savedFilter, error_6;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    trimmedName = customFilterName.trim();
                    if (!trimmedName) {
                        setCustomFilterNameError('Filter name is required.');
                        return [2];
                    }
                    setCustomFilterNameError('');
                    isEditing = editingFilterId !== '' && editingFilterId !== null && editingFilterId !== undefined;
                    payload = {
                        ConfigType: "APP_MANAGMENT_FILTER_CONFIG",
                        RecordId: isEditing ? editingFilterId : null,
                        FilterName: trimmedName,
                        FilterConfig: __assign(__assign({}, getDraftFilterPayload()), { filterName: trimmedName, uniqueStatus: sanitizeUniqueStatusesForSave(Array.isArray(draftUniqueStatus) ? draftUniqueStatus : []) }),
                    };
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 6, , 7]);
                    return [4, api_service.post({
                            endPoint: api_urls.ADMIN_PREFERENCES,
                            payLoad: payload,
                            showLoader: true,
                        })];
                case 2:
                    response = _b.sent();
                    if (!(((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.statusCode) === 200)) return [3, 5];
                    savedFilterValue = isEditing
                        ? editingFilterId
                        : (resolveSavedFilterValueFromResponse(response) || "local-".concat(Date.now()));
                    savedFilter = {
                        label: trimmedName,
                        value: savedFilterValue,
                        filters: __assign(__assign({}, getDraftFilterPayload()), { uniqueStatus: sanitizeUniqueStatusesForApply(Array.isArray(draftUniqueStatus) ? draftUniqueStatus : []) }),
                    };
                    upsertSavedFilter(savedFilter);
                    setSaveFilterModalOpen(false);
                    setEditingFilterId('');
                    hasUserModifiedDraftRef.current = false;
                    setDraftSavedFilter(savedFilter.value);
                    setSelectedSavedFilter === null || setSelectedSavedFilter === void 0 ? void 0 : setSelectedSavedFilter(savedFilter.value);
                    return [4, fetchAdminPreferences({
                            value: savedFilter.value,
                            label: trimmedName,
                        })];
                case 3:
                    _b.sent();
                    return [4, Promise.resolve(onSaveAsNewFilter === null || onSaveAsNewFilter === void 0 ? void 0 : onSaveAsNewFilter(savedFilter))];
                case 4:
                    _b.sent();
                    _b.label = 5;
                case 5: return [3, 7];
                case 6:
                    error_6 = _b.sent();
                    return [3, 7];
                case 7: return [2];
            }
        });
    }); };
    var handleApply = function () {
        var shouldClearSavedFilterSelection = isResetPending || (hasUserModifiedDraftRef.current && isSavedFilterDirty);
        var nextSavedFilterSelection = shouldClearSavedFilterSelection ? '' : draftSavedFilter;
        setSelectedSavedFilter === null || setSelectedSavedFilter === void 0 ? void 0 : setSelectedSavedFilter(nextSavedFilterSelection);
        if (shouldClearSavedFilterSelection && draftSavedFilter !== '') {
            setDraftSavedFilter('');
        }
        if (isResetPending) {
            hasUserModifiedDraftRef.current = false;
            handleResetFilters();
            onApply();
            return;
        }
        var payload = getDraftFilterPayload();
        applyBacklogFilters(__assign({ vendor: payload.vendor, status: payload.statusGroup, programs: payload.programs, searchText: payload.searchText, uniqueStatus: payload.uniqueStatus, salesRep: payload.salesRep, dealers: payload.dealers }, (payload.ForecastDataRange ? { ForecastDataRange: payload.ForecastDataRange } : {})));
        hasUserModifiedDraftRef.current = false;
        onApply();
    };
    var handleCancel = function () {
        var _a, _b;
        hasUserModifiedDraftRef.current = false;
        var sanitizedSelectedVendor = sanitizeVendor(selectedVendor);
        setDraftVendor(sanitizedSelectedVendor);
        setDraftStatus(selectedStatus);
        setDraftSearchText(searchText);
        setDraftPrograms(selectedPrograms);
        setDraftUniqueStatus(sanitizeUniqueStatusesForApply(selectedUniqueStatus));
        setDraftSalesRep(Array.isArray(selectedSalesRep) ? selectedSalesRep : []);
        setDraftDealers(Array.isArray(selectedDealers) ? selectedDealers : []);
        var nextStartDate = normalizeDateForPayload((_a = selectedDateRange === null || selectedDateRange === void 0 ? void 0 : selectedDateRange.StartDate) !== null && _a !== void 0 ? _a : '');
        var nextEndDate = normalizeDateForPayload((_b = selectedDateRange === null || selectedDateRange === void 0 ? void 0 : selectedDateRange.EndDate) !== null && _b !== void 0 ? _b : '');
        setDraftForecastStartDate(nextStartDate);
        setDraftForecastEndDate(nextStartDate ? nextEndDate : '');
        setDraftSavedFilter(selectedSavedFilter);
        setIsResetPending(false);
        onCancel();
    };
    var showEmptySavedFilterOption = savedFilterOptions.length === 0;
    return (React.createElement(React.Fragment, null,
        React.createElement(FilterPanelWrapper, { sx: { height: '100%', minHeight: 0 } },
            React.createElement(FilterHeader, null,
                React.createElement(Typography, { variant: 'h6' }, "Filter By"),
                React.createElement(Stack, { direction: "row", sx: { gap: '6px', alignItems: 'center', color: baseColors.successPreset[30], cursor: 'pointer', fontSize: 13 }, onClick: handleResetClick },
                    React.createElement("span", { className: "icon-Reload", style: {
                            display: 'inline-block',
                            transform: isResetAnimating ? 'rotate(360deg)' : 'rotate(0deg)',
                            transition: 'transform 0.45s ease',
                        } }),
                    React.createElement(Typography, { variant: "subtitle2" }, isResetAnimating ? 'Resetting...' : 'Reset'))),
            React.createElement(FilterBody, { sx: { height: 'auto', minHeight: 0, flex: '1 1 auto' } },
                React.createElement(FilterSection, null,
                    React.createElement(Select, { displayEmpty: true, value: draftSavedFilter, onChange: function (e) { return handleSavedFilterChange(e.target.value); }, size: "small", fullWidth: true, renderValue: function (val) {
                            var _a;
                            if (val === '' || val === null || val === undefined) {
                                return React.createElement("span", { style: { color: baseColors.greyPreset[5], fontSize: 14 } }, "Select Saved Filter");
                            }
                            var selectedOptionLabel = (_a = savedFilterOptions.find(function (f) { return String(f.value) === String(val); })) === null || _a === void 0 ? void 0 : _a.label;
                            if (!selectedOptionLabel) {
                                return React.createElement("span", { style: { color: baseColors.greyPreset[5], fontSize: 14 } }, "Select Saved Filter");
                            }
                            return (React.createElement("span", { style: {
                                    fontSize: 13,
                                    color: isSavedFilterDirty ? baseColors.errorPreset[20] : baseColors.darkPreset[10],
                                } }, selectedOptionLabel));
                        }, sx: {
                            fontSize: 13,
                            '& .MuiOutlinedInput-notchedOutline': {
                                borderColor: isSavedFilterDirty ? baseColors.errorPreset[20] : baseColors.greyPreset[20],
                            },
                            '&:hover .MuiOutlinedInput-notchedOutline': {
                                borderColor: isSavedFilterDirty ? baseColors.errorPreset[10] : baseColors.successPreset[10],
                            },
                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                borderColor: isSavedFilterDirty ? baseColors.errorPreset[20] : baseColors.successPreset[30],
                            },
                            '& .MuiSelect-icon': {
                                color: isSavedFilterDirty ? baseColors.errorPreset[20] : undefined,
                            },
                        } },
                        showEmptySavedFilterOption && (React.createElement(MenuItem, { value: "", sx: { fontSize: 13 } },
                            React.createElement("em", null, "None"))),
                        savedFilterOptions.map(function (f) { return (React.createElement(MenuItem, { key: f.value, value: f.value, sx: { fontSize: 13 } }, f.label)); }))),
                React.createElement(FilterSection, null,
                    React.createElement(Typography, { className: "filter-section-label" }, "Portal Name"),
                    React.createElement(BacklogFilterSelect, { options: (vendorList !== null && vendorList !== void 0 ? vendorList : []).filter(function (item) { return item.Id !== 'All'; }), displayKey: "Name", valueKey: "Id", placeholder: "Select Portal Name", selectedValue: (draftVendor === null || draftVendor === void 0 ? void 0 : draftVendor.Id) !== 'All' ? draftVendor : null, onSelectionChange: handleDraftVendorChange })),
                React.createElement(FilterSection, null,
                    React.createElement(Typography, { className: "filter-section-label" }, "Dealership"),
                    React.createElement(BacklogFilterSelect, { options: dealersList, displayKey: "label", valueKey: "value", placeholder: "Select Dealership", selectedValue: draftDealers, onSelectionChange: handleDraftDealersChange, onOpen: handleDealersDropdownOpen, onInputChange: handleDealersInputChange, onLoadMore: handleDealersLoadMore, loading: dealersLoading, loadingMore: dealersLoadingMore, errorText: dealersError, serverSideFilter: true, multiple: true })),
                React.createElement(FilterSection, null,
                    React.createElement(Typography, { className: "filter-section-label" }, "Programs"),
                    React.createElement(BacklogFilterSelect, { options: programsList, displayKey: "label", valueKey: "value", placeholder: "Select Programs", selectedValue: draftPrograms, onSelectionChange: handleDraftProgramsChange, multiple: true })),
                React.createElement(FilterSection, null,
                    React.createElement(Typography, { className: "filter-section-label" }, "Internal Sales Rep"),
                    React.createElement(BacklogFilterSelect, { options: salesRepList, displayKey: "label", valueKey: "value", placeholder: "Select Internal Sales Rep", selectedValue: (_d = draftSalesRep === null || draftSalesRep === void 0 ? void 0 : draftSalesRep[0]) !== null && _d !== void 0 ? _d : null, onSelectionChange: handleDraftSalesRepChange, onOpen: handleSalesRepDropdownOpen })),
                React.createElement(FilterSection, null,
                    React.createElement(Typography, { className: "filter-section-label" }, "Status Group"),
                    React.createElement(StatusChipGroup, null, BacklogStatusGroups.map(function (status) { return (React.createElement(StatusChip, { key: status.value, selected: (draftStatus === null || draftStatus === void 0 ? void 0 : draftStatus.value) === status.value, onClick: function () { return onDraftStatusChipClick(status); } }, status.label)); }))),
                React.createElement(FilterSection, null,
                    React.createElement(Typography, { className: "filter-section-label" }, "Status"),
                    React.createElement(BacklogFilterSelect, { options: filteredUniqueStatusList, displayKey: "label", valueKey: "value", placeholder: "Select Status", selectedValue: draftUniqueStatus, onSelectionChange: handleDraftUniqueStatusChange, multiple: true })),
                React.createElement(FilterSection, null,
                    React.createElement(Typography, { className: "filter-section-label" }, "Forecast Date"),
                    React.createElement("style", null, "\n                        .react-datepicker-wrapper {\n                            position: relative;\n                            display: block;\n                            width: 100%;\n                        }\n                        .react-datepicker__calendar-icon {\n                            position: absolute;\n                            right: 12px;\n                            top: 50%;\n                            transform: translateY(-50%);\n                            cursor: pointer;\n                            z-index: 2;\n                            pointer-events: auto;\n                            display: flex;\n                            align-items: center;\n                            opacity: 1;\n                            transition: opacity 0.2s ease;\n                        }\n                        .forecast-date-with-selection .react-datepicker__calendar-icon {\n                            display: none;\n                            opacity: 0;\n                        }\n                    "),
                    React.createElement("div", { className: draftForecastStartDate || draftForecastEndDate ? 'forecast-date-with-selection' : '' },
                        React.createElement(ReactDatePicker, { selectsRange: true, isClearable: true, showIcon: true, toggleCalendarOnIconClick: true, dateFormat: "MM/dd/yyyy", placeholderText: "MM/DD/YYYY - MM/DD/YYYY", startDate: parsePayloadDate(draftForecastStartDate), endDate: parsePayloadDate(draftForecastEndDate), onChange: function (update) { return handleDraftForecastDateRangeChange(update !== null && update !== void 0 ? update : [null, null]); }, customInput: (React.createElement(MuiTextField, { size: "small", fullWidth: true, sx: {
                                    '& .MuiInputBase-input': {
                                        fontSize: 13,
                                        paddingRight: draftForecastStartDate || draftForecastEndDate ? '12px' : '36px',
                                    },
                                } })) })))),
            React.createElement(FilterFooter, null,
                React.createElement(Stack, { direction: "row", gap: 1, width: "100%" },
                    Boolean(draftSavedFilter && selectedDraftSavedFilterItem) && isSavedFilterDirty && (React.createElement(CustomButton, { variant: "secondary", onClick: handleOpenUpdateModal, fullWidth: true, SMButton: true, startIcon: React.createElement("span", { className: "icon-Save" }) }, "Update Saved Filter")),
                    React.createElement(CustomButton, { variant: "secondary", onClick: handleOpenSaveModal, disabled: disableSaveAsNewFilter, fullWidth: true, SMButton: true, startIcon: React.createElement("span", { className: "icon-Save" }) }, "Save As New Filter")),
                React.createElement(FilterFooterActions, null,
                    React.createElement(CustomButton, { variant: "contained", onClick: handleApply, fullWidth: true, SMButton: true }, "Apply"),
                    React.createElement(CustomButton, { variant: "secondary", onClick: handleCancel, fullWidth: true, SMButton: true }, "Cancel")))),
        React.createElement(Modal, { open: saveFilterModalOpen, onClose: function () { setSaveFilterModalOpen(false); setEditingFilterId(''); } },
            React.createElement(Box, { sx: {
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 480,
                    bgcolor: '#fff',
                    borderRadius: 2,
                    boxShadow: 24,
                    display: 'flex',
                    flexDirection: 'column',
                } },
                React.createElement(Box, { sx: {
                        px: 3,
                        py: 2,
                        borderBottom: "1px solid ".concat(baseColors.greyPreset[40]),
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    } },
                    React.createElement(Typography, { fontWeight: 700, fontSize: 16 }, editingFilterId ? 'Update Saved Filter' : 'New Custom Filter'),
                    React.createElement(CloseIcon, { onClick: function () { setSaveFilterModalOpen(false); setEditingFilterId(''); }, sx: { cursor: 'pointer', color: baseColors.greyPreset[30], fontSize: 22, '&:hover': { color: baseColors.darkPreset[10] } } })),
                React.createElement(Box, { sx: { px: 3, pt: 2.5, pb: 1 } },
                    React.createElement(Typography, { variant: "body2", fontWeight: 500, mb: 0.75 },
                        "Enter Custom filter name",
                        React.createElement(Box, { component: "span", sx: { color: 'error.main', ml: 0.5 } }, "*")),
                    React.createElement(MuiTextField, { fullWidth: true, size: "small", placeholder: "My Custom Filter", value: customFilterName, onChange: function (e) {
                            setCustomFilterName(e.target.value);
                            if (e.target.value.trim())
                                setCustomFilterNameError('');
                        }, error: Boolean(customFilterNameError), helperText: customFilterNameError, inputProps: { maxLength: 100 }, autoFocus: true, sx: {
                            '& .MuiOutlinedInput-root': {
                                borderRadius: '8px',
                                '& fieldset': { borderColor: baseColors.greyPreset[40] },
                                '&:hover fieldset': { borderColor: baseColors.greyPreset[30] },
                                '&.Mui-focused fieldset': { borderColor: baseColors.successPreset[30], borderWidth: '1px' },
                            },
                        } })),
                React.createElement(Box, { sx: {
                        px: 3,
                        py: 2,
                        display: 'flex',
                        gap: 2,
                        justifyContent: 'flex-end',
                    } },
                    React.createElement(CustomButton, { variant: "contained", onClick: handleSaveNewFilter, SMButton: true, fullWidth: false }, editingFilterId ? 'Update' : 'Save'),
                    React.createElement(CustomButton, { variant: "secondary", onClick: function () { setSaveFilterModalOpen(false); setEditingFilterId(''); }, SMButton: true, fullWidth: false }, "Cancel"))))));
};
export default Filter;
